import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import "./../styles/components/statusDropdown.css";

interface StatusDropdownProps {
  onSelect?: (category: string) => void;
}

const status = [
  ["Tất cả", "Chờ Duyệt", "Đã duyệt", "Từ chối"],
];

const StatusDropdown: React.FC<StatusDropdownProps> = ({ onSelect }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState<string>("Tất cả");
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handle = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  const handleClick = (cat: string) => {
    setActive(cat);
    setOpen(false);
    onSelect && onSelect(cat);
  };

  return (
    <div className="status-dropdown" ref={ref}>
      <button className="status-btn" onClick={() => setOpen((s) => !s)}>
        <span className="status-label">Trạng thái</span>
        <ChevronDown size={16} />
      </button>

      {open && (
        <div className="status-menu" role="menu">
          {status.map((col, i) => (
            <div key={i} className="status-column">
              {col.map((item) => (
                <div
                  key={item}
                  className={`status-item ${active === item ? "active" : ""}`}
                  onClick={() => handleClick(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;
